import { render, staticRenderFns } from "./file-parse-format.vue?vue&type=template&id=0245b040&"
import script from "./file-parse-format.vue?vue&type=script&lang=ts&"
export * from "./file-parse-format.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports